import * as HLF from "html-living-framework";
import { AppProgress } from "../Data/AppProgress";
import * as Constants from "../Data/Constants";
import * as DollData from "../Data/DollData";
import { GalleryPaintableData } from "../Data/GalleryPaintableData";
import { GameType } from "../Data/GameData";
import * as VoiceOver from "../Data/VoiceOver";
import { PaintableDoll } from "../GameObjects/PaintableDoll";
import { GamePaintable } from "../States/GamePaintable";

export class GameDoll extends GamePaintable {
    protected readonly _gameType = GameType.DOLL;
    protected readonly _colours: number[] = [
        // Bear
        (new HLF.Colour(234, 186, 0)).toHex(), // Yellow
        (new HLF.Colour(254, 109, 114)).toHex(), // Salmon
        (new HLF.Colour(220, 5, 10)).toHex(), // Red
        (new HLF.Colour(41, 157, 34)).toHex(), // Lime Green
        (new HLF.Colour(2, 69, 26)).toHex(), // Forest Green
        (new HLF.Colour(6, 149, 191)).toHex(), // Cyan
        (new HLF.Colour(0, 24, 148)).toHex(), // Blue
        // Matryoshka
        (new HLF.Colour(143, 36, 0)).toHex(), // Maroon
        (new HLF.Colour(119, 9, 170)).toHex(), // Purple
        (new HLF.Colour(99, 132, 201)).toHex(), // Frost
        (new HLF.Colour(153, 33, 87)).toHex(), // Burghundy
        (new HLF.Colour(23, 217, 227)).toHex(), // Cyan
        (new HLF.Colour(191, 93, 6)).toHex(), // Orange
        (new HLF.Colour(0, 0, 52)).toHex(), // Blue
    ];

    constructor() {
        super();
        this._funFactCommon = VoiceOver.FUN_FACT_DOLL_COMMON;
        this._funFactUnique = VoiceOver.FUN_FACT_DOLL_UNIQUE;

        this._palette.setColours(this._colours);

        for (let i = 0; i < DollData.DATA.length; ++i) {
            this._paintables.push(new PaintableDoll(i));
            const data: GalleryPaintableData = AppProgress.games[this._gameType].saveData[i] as GalleryPaintableData;
            if (data !== undefined) {
                for (let j = 0; j < data.sequence.length; ++j) {
                    this._paintables[i].layers[data.sequence[j]].paint(
                        data.colours[data.sequence[j]],
                        0, 0, true, true,
                    );
                }
            }
            this.addChild(this._paintables[i]);
            this.setChildIndex(this._paintables[i], 4);
        }

        HLF.PixiUtils.sendToFront(this._andy);
        HLF.PixiUtils.sendToFront(this._buttonSubmit);
        HLF.PixiUtils.sendToFront(this._buttonClear);
        HLF.PixiUtils.sendToFront(this._keyboardFocusManager);
    }

    public static getRequiredAssets(): string[] {
        const required = super.getRequiredAssets();
        for (let i = 0; i < DollData.DATA.length; ++i) {
            required.push(Constants.SPRITESHEET_DOLL_PREFIX + "0" + i + HLF.ResourceUtils.FILE_EXTENSION_JSON);
        }
        return required;
    }

    public init(pSize: PIXI.Point): void {
        super.init(pSize);

        if (this._isOnboarding === false) {
            this._activePaintableIndex = HLF.Random.intBetween(0, DollData.DATA.length);
            this._currentFunFactIndex = 0;
        }
        for (let i = 0; i < DollData.DATA.length; ++i) {
            this._paintables[i].visible = (i === this._activePaintableIndex);
        }
    }
}
